import React, { useEffect } from "react";
import { createContext } from "react";
import { getUid, loginWithLocalStorageToken } from "../auth/user";
import { auth } from "../firebase";

export const AuthContext = createContext({
  uid: undefined as string | undefined,
});

export const AuthProvider = ({ children }: { children: any }) => {
  const [uid, setUid] = React.useState(getUid());

  auth.onAuthStateChanged((user) => {
    setUid(user?.uid);
  });

  useEffect(() => {
    if (!uid) {
      //loginWithLocalStorageToken();
    }
  }, [uid]);
  return (
    <AuthContext.Provider value={{ uid }}>{children}</AuthContext.Provider>
  );
};
